export default function useApiDoc() {
  const route = useRoute()

  const version = ref<ApiVersion>(route.query.version as ApiVersion || 'v2')
  const versionFetched = ref<ApiVersion>()

  watch(
    () => route.query.version,
    (newVersion) => {
      version.value = newVersion as ApiVersion || 'v2'
    },
  )

  const refreshResponseWithApiVersion = async (params: {
    api: any
    execute: any
    response: any
    visibility: boolean
  }) => {
    if (params.visibility && version.value !== versionFetched.value) {
      params.api.updateApiVersion(version.value)

      await params.execute()

      versionFetched.value = version.value

      // It’s important to switch the API instance back to v2 for subsequent requests.
      if (version.value === 'v1') {
        params.api.updateApiVersion('v2')
      }
    }
  }

  return {
    refreshResponseWithApiVersion,
    version,
    versionFetched,
  }
}
